export default "__VITE_ASSET__CHPoXrAa__"